import { Navigate, useLocation } from 'react-router-dom';
import { usePessoaAuthStore } from '../stores/pessoa-auth.store';

interface ProtectedPessoaRouteProps {
  children: React.ReactNode;
}

// Sprint 3.8 — equivalente a `ProtectedRoute.tsx`, mas pra sessão de Pessoa
// (Área do Cliente): lê `usePessoaAuthStore`, nunca `useAuthStore`, e manda
// pra `/area-cliente/login`, nunca `/auth/login`.
export function ProtectedPessoaRoute({ children }: ProtectedPessoaRouteProps) {
  const { isAuthenticated } = usePessoaAuthStore();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/area-cliente/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
